<template>
  <div id="client-access-list">

      <b-card>
        <b-row class="mb-4">
          <b-col md="3">
            <label for="filter-mdtp-provider-service">Serviço</label>
            <v-select
              id="filter-mdtp-provider-service"
              placeholder="Selecione um serviço"
              v-model="filterService.service"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              label="name"
              :options="mdtpProviderServices"
              :clearable="true"
              @input="onServiceFilterChange"
            >
              <span slot="no-options">{{ $t("GENERAL.NoOptions") }}</span>
            </v-select>
          </b-col>
        </b-row>
        <b-tabs>
          <b-tab title="MDTP Provider Status">
            <b-overlay
              variant="white"
              :show="tableLoading"
              spinner-variant="primary"
              blur="0"
              opacity=".75"
              rounded="sm"
            >
            <custom-g-table 
              v-if="displayTable" 
              ref="custom-table" 
              :displayLoading="tableLoading" 
              :fields="fields"
              :items="data" 
              :totalRows="totalRows" 
              :limit="limit" 
              :hasResendButton="true" 
              :hasUpdateDataButton="true"
              :hasAdvancedFilterButton="true" 
              :hasPerPageSelect="true"
              :advancedFilters="advancedFilters" 
              @changePage="onChangePage" 
              @onColumnFilter="onFilter"
              @onResend="onResend"
              @updateData="updateData" 
              @fetchAdvancedFilter="onFilter"
              @limitChanged="onLimitChanged" 
            />
          </b-overlay>
          </b-tab>
        </b-tabs>
      </b-card>
    
  </div>
</template>

<script>
import {
  BCard,
  BTab,
  BTabs,
  // BButton,
  BCol,
  BRow,
  // BFormGroup,
  BOverlay
} from "bootstrap-vue";
import CustomGTable from "@/views/custom/table/CustomGTable.vue";
import { setRouteQuery, buildParamsRouteQuery } from "@/helpers/route-query-helper";
import AppConstants from "@/appConstants";
import newsService from "@/providers/newsService";
import dropdownService from "@/providers/dropdownService";
import messagesNotifyHelper from '@/helpers/messages-notify-helper';
import messageDialogHelper from '@/helpers/message-dialog-helper';
import vSelect from "vue-select";
import { onlyLatestRequest } from "@/helpers/latest-request-helper";
// import flatPickr from "vue-flatpickr-component";

export default {
  props: {
    urlQuery: Object
  },
  components: {
    BCard,
    BTab,
    BTabs,
    // BButton,
    BCol,
    BRow,
    // BFormGroup,
    BOverlay,
    CustomGTable,
    vSelect,
    // flatPickr,
  },
  data() {
    return {
      displayTable: false, 
      data: [],
      totalRows: 0,
      limit: AppConstants.PAGINATOR_DEFAULT_LIMIT,
      page: 1,
      tableLoading: true,
      importingIpv4Database: false,
      syncParamsForm: {
        origin: null
      },
      isSyncing: false,
      filters: {},
      filterService: {
        service: null
      },
      mdtpProviderServices: [],
      fields: [
        { field: "action_buttons", label: "Ações", sortable: false },
        { field: "external_uuid", label: "External UUID", sortable: false },
        { field: "id_publisher", label: "ID Publisher", sortable: false },
        { field: "iss", label: "ISS", sortable: false },
        { field: "source_code", label: "Origens", sortable: false },
        { field: "subjects", label: "Assuntos", sortable: false },
        { field: "title", label: "Titulo", sortable: false },
        { field: "status", label: "Status", sortable: false },
        { field: "errorMessage", label: "Mensagem Error", sortable: false },
        { field: "event_status_name", label: "Status Noticia Publisher", sortable: false },
        { field: "dt_publish", label: "Data Publicação Publisher", type: "custom_date", sortable: false },
        { field: "dt_update", label: "Data Atualização", type: "custom_date", sortable: false },
        { field: "created", label: "Data de Criação", type: "custom_date", sortable: false },
        { field: "_id", label: "ID", sortable: false },
      ],
      advancedFilters: [
        { field: "external_uuid", label: "External UUID", type: 'input', value: '', size: 2 },
        { field: "id_publisher", label: "ID Publisher", type: 'input', value: '', size: 2 },
        { field: "iss", label: "ISS", type: 'input', value: '', size: 2 },
        { field: "title", label: "Titulo", type: 'input', value: '', size: 2 },
        { field: "status", label: "Status", type: 'input', value: '', size: 2 },
        { field: "status", label: "Status", type: 'dropdown', value: '', size: 2, multiple: false, filterDropdownItems: [
          { name: 'OK', value: 'OK' },
          { name: 'ERROR', value: 'ERROR' }
        ] },
        // { field: "event_status", label: "Status Noticia Publisher", type: 'input', value: '', size: 2 },
      ],
    };
  },
  mounted() {
    this.$store.dispatch("admin/updatePageTitle", "MDTP Provider Status");
    this.loadDataFilter();
    this.setInitialTableFilters();
  },
  computed: {
    searchParams() {
      const params = buildParamsRouteQuery(this.$route.query);

      params.append("page", this.page);
      params.append("limit", this.limit);

      if (this.filterService.service) {
        params.append("service", this.filterService.service.id);
      }

      // this.advancedFilters.forEach(filter => {
      //   if (filter.value) {
      //     params.append(filter.field, filter.value);
      //   }
      // });
      return params;
    },
  },
  methods: {
    onResend(data) {
      if (data.event_status == AppConstants.EVENT_STATUS.PUBLISHED) {
        messagesNotifyHelper.warningNotify('Aviso', 'Não pode ser reenviado uma noticia com status de Publicado');
        return;
      }
      messageDialogHelper.displayConfirmMessage(
        "Noticia",
        "Certeza que deseja de reenviar a noticia?",
        () => {
          newsService
            .mdtpProviderJwtResend({_id: data._id}, new URLSearchParams())
            .then(() => {
              messagesNotifyHelper.successNotify('Sucecsso','Noticia reenviado com sucesso.');
            })
            .catch((err) => {
              console.log(err);
              messagesNotifyHelper.errorNotify('Error', err);
            });
        });
    },
    onLimitChanged(newLimit) {
      this.limit = newLimit;
      this.loadData();
    },
    loadDataFilter() {
      dropdownService
        .getMdtpProviderService(new URLSearchParams())
        .then((res) => {
          this.mdtpProviderServices = res;
        })
        .catch((err) => console.log(err));
    },
    onServiceFilterChange() {
      this.page = 1;
      this.loadData();
    },
    setInitialTableFilters() {
      // Object.keys(this.urlQuery).forEach(item => {
      //   this.fields[this.fields.findIndex(val => val.field==item)].filterOptions.filterValue = this.urlQuery[item];
      // });
      Object.keys(this.urlQuery).forEach(item => {
        this.advancedFilters[this.advancedFilters.findIndex(val => val.field == item)].value = this.urlQuery[item];
      });
      this.loadData();
    },
    onChangePage(page) {
      this.page = page;
      this.loadData();
    },
    onFilter(data) {
      console.log('onFilter', data);
      this.filters = data;
      setRouteQuery(data, this.$route.query);
      this.loadData();
    },
    loadData() {
      this.data = [];
      this.tableLoading = true;
      // this.displayTable = false;
      onlyLatestRequest(this, 'loadData', newsService.mdtpProviderStatusAll(this.searchParams))
        .then((res) => {
          this.displayTable = true;
          this.data = res.data
          this.totalRows = res.totalRows;
          this.tableLoading = false;
        })
        .catch((err) => {
          this.tableLoading = false;
          console.log(err);
        });
    },
    clearFilters() {
      this.fields.forEach(field => {
        if (field.filterOptions && field.filterOptions.filterValue !== undefined) {
          field.filterOptions.filterValue = '';
        }
      });
      const query = { ...this.$route.query };
      Object.keys(query).forEach(key => {
        if (!['page', 'limit', 'lang'].includes(key)) {
          delete query[key];
        }
      });
      this.$router.replace({ query });
      this.$forceUpdate();
    },
    updateData() {
      this.loadData();
    },

    
  }

};
</script>